import { CircularProgress } from "@mui/joy";

interface Props {
    estatus: string;
    isDirty: boolean;
    changeStatusIsLoading: boolean;
    submitChangeStatus: (status: boolean) => Promise<void>;
}

export function ChangeStatusButtons({ estatus, isDirty, submitChangeStatus, changeStatusIsLoading }: Props) {

    return (
        <>
            {changeStatusIsLoading
            ?
            <CircularProgress sx={{
                "--CircularProgress-size": "30px",
                "--CircularProgress-trackThickness": "3px",
                "--CircularProgress-progressThickness": "3px"
            }}/>
            :
            <>
            {estatus == "Abierta" && !isDirty && (
            <button
                type="button"
                className="bg-purple-700 hover:bg-purple-900 h-[30px] rounded px-[15px] py-[4px] flex gap-1 items-center text-white"
                onClick={() => submitChangeStatus(true)}>
                Terminar tarea
            </button>
            )}

            {estatus == "Terminada" && !isDirty && (
            <button
                type="button"
                className="bg-green-800 hover:bg-green-900 h-[30px] rounded px-[15px] py-[4px] flex gap-1 items-center text-white"
                onClick={() => submitChangeStatus(false)}>
                Abrir tarea
            </button>
            )}
            </>
            }
        </>
    );
}